import { Store, Link2, Rocket, ShoppingBag, TrendingUp, RefreshCw, Palette, Gift } from 'lucide-react';
import { WhatsNewConfig } from '../interface/whats-new.interface';

import createStorefrontDesktop from '../../assets/images/new-feature-popup/desktop/create-your-storefront.png';
import personalizeDesktop from '../../assets/images/new-feature-popup/desktop/personalize.png';
import buildInMinutesDesktop from '../../assets/images/new-feature-popup/desktop/build-in-minutes.png';
import shareDesktop from '../../assets/images/new-feature-popup/desktop/share.png';
import trackWhatWorksDesktop from '../../assets/images/new-feature-popup/desktop/track-what-works.png';
import powerfulToolDesktop from '../../assets/images/new-feature-popup/desktop/powerful-tool.png';

import createStorefrontMobile from '../../assets/images/new-feature-popup/mobile/create-your-storefront.png';
import personalizeMobile from '../../assets/images/new-feature-popup/mobile/personalize.png';
import buildInMinutesMobile from '../../assets/images/new-feature-popup/mobile/build-in-minutres.png';
import shareMobile from '../../assets/images/new-feature-popup/mobile/share.png';
import trackWhatWorksMobile from '../../assets/images/new-feature-popup/mobile/track.png';
import completeCreatorToolkitMobile from '../../assets/images/new-feature-popup/mobile/complete-creator-toolkit.png';

/**
 * All feature announcements currently shipped, oldest first. To ship a new
 * "What's New" walkthrough: add its row to the backend `popups` table, then
 * append a WhatsNewConfig here whose `popupName` matches that row, declaring
 * its `audience` (only 'influencer' and 'brand' are ever eligible —
 * agency/talent-partner never see this modal) and `requiresSubscription`.
 * Only the last entry FOR THE CURRENT USER'S AUDIENCE (see
 * getLatestWhatsNewConfigForAudience) is ever shown, and only while the
 * popups row still has view budget left for that account.
 */
export const WHATS_NEW_CONFIGS: WhatsNewConfig[] = [
    {
        popupName: 'introducing_zap',
        title: 'Storefront & Link in Bio',
        // Built as part of Zap, the influencer storefront/link-in-bio surface —
        // brand has its own separate storefront feature, not this one. An
        // image-driven walkthrough: each slide is a self-contained poster with
        // the copy baked into the artwork.
        audience: ['influencer'],
        requiresSubscription: true,
        slides: [
            {
                id: 'create-storefront',
                image: {
                    desktop: createStorefrontDesktop,
                    mobile: createStorefrontMobile,
                    alt: 'Create your storefront',
                },
            },
            {
                id: 'personalize',
                image: {
                    desktop: personalizeDesktop,
                    mobile: personalizeMobile,
                    alt: 'Personalize every detail',
                },
            },
            {
                id: 'build-in-minutes',
                image: {
                    desktop: buildInMinutesDesktop,
                    mobile: buildInMinutesMobile,
                    alt: 'Build in minutes',
                },
            },
            {
                id: 'share',
                image: {
                    desktop: shareDesktop,
                    mobile: shareMobile,
                    alt: 'One link, everything you share',
                },
            },
            {
                id: 'track-what-works',
                image: {
                    desktop: trackWhatWorksDesktop,
                    mobile: trackWhatWorksMobile,
                    alt: 'Track what works',
                },
            },
            {
                id: 'powerful-tools',
                image: {
                    desktop: powerfulToolDesktop,
                    mobile: completeCreatorToolkitMobile,
                    alt: 'Powerful tools, endless possibilities',
                },
            },
        ],
    },
];

/** The most-recent announcement targeting this audience — the only one eligible to show. */
export const getLatestWhatsNewConfigForAudience = (audience: WhatsNewConfig['audience'][number]): WhatsNewConfig | null => {
    const eligible = WHATS_NEW_CONFIGS.filter((c) => c.audience.includes(audience));
    if (!eligible.length) return null;
    return eligible[eligible.length - 1];
};
